import React from 'react'

const adapt = Component => ({ input, meta: { touched, valid }, ...rest }) => (
  <Component {...input} {...rest} valid={!touched ? undefined : valid} />
)

export default adapt
